export const EXAMPLE_IMPORT_LICENSES_CSV_HEADERS = [
  { key: 'property', displayLabel: 'Property' },
  { key: 'sport', displayLabel: 'Sport' },
  { key: 'geo_listing', displayLabel: 'GEO Listing' },
  { key: 'auto_booking', displayLabel: 'Auto Booking / Manual Booking' },
  { key: 'license_start_date_1', displayLabel: 'License Start Date 1' },
  { key: 'license_end_date_1', displayLabel: 'License End Date 1' },
  { key: 'max_events_1', displayLabel: 'Max Events 1' },
  { key: 'purchased_events_1', displayLabel: 'Purchased Events 1' },
  { key: 'license_start_date_2', displayLabel: 'License Start Date 2' },
  { key: 'license_end_date_2', displayLabel: 'License End Date 2' },
  { key: 'max_events_2', displayLabel: 'Max Events 2' },
  { key: 'purchased_events_2', displayLabel: 'Purchased Events 2' },
  { key: 'license_start_date_3', displayLabel: 'License Start Date 3' },
  { key: 'license_end_date_3', displayLabel: 'License End Date 3' },
  { key: 'max_events_3', displayLabel: 'Max Events 3' },
  { key: 'purchased_events_3', displayLabel: 'Purchased Events 3' }
]

export const EXAMPLE_IMPORT_LICENSES_CSV_DATA = [
  {
    property: 'License property name 1',
    sport: 'Sport name',
    geo_listing: 'ALLOW(All, New Jersey, California) EXCEPT(Sweden, Singapore)',
    auto_booking: 'Auto Booking/Manual Booking',
    license_start_date_1: 'DD/MM/YYYY',
    license_end_date_1: 'DD/MM/YYYY',
    max_events_1: '',
    purchased_events_1: '',
    license_start_date_2: 'DD/MM/YYYY',
    license_end_date_2: 'DD/MM/YYYY',
    max_events_2: '',
    purchased_events_2: '',
    license_start_date_3: 'DD/MM/YYYY',
    license_end_date_3: 'DD/MM/YYYY',
    max_events_3: '',
    purchased_events_3: ''
  },
  {
    property: 'License property name 2',
    sport: 'Sport name',
    geo_listing: 'BLOCK(All, New Jersey, California) EXCEPT(Sweden, Singapore)',
    auto_booking: 'Auto Booking/Manual Booking',
    license_start_date_1: 'DD/MM/YYYY',
    license_end_date_1: 'DD/MM/YYYY',
    max_events_1: '',
    purchased_events_1: '',
    license_start_date_2: 'DD/MM/YYYY',
    license_end_date_2: 'DD/MM/YYYY',
    max_events_2: '',
    purchased_events_2: '',
    license_start_date_3: 'DD/MM/YYYY',
    license_end_date_3: 'DD/MM/YYYY',
    max_events_3: '',
    purchased_events_3: ''
  },
  {
    property: 'License property name 2',
    sport: 'Sport name',
    geo_listing: 'ALLOW(All)',
    auto_booking: 'Auto Booking/Manual Booking',
    license_start_date_1: 'DD/MM/YYYY',
    license_end_date_1: 'DD/MM/YYYY',
    max_events_1: '',
    purchased_events_1: '',
    license_start_date_2: 'DD/MM/YYYY',
    license_end_date_2: 'DD/MM/YYYY',
    max_events_2: '',
    purchased_events_2: '',
    license_start_date_3: 'DD/MM/YYYY',
    license_end_date_3: 'DD/MM/YYYY',
    max_events_3: '',
    purchased_events_3: ''
  }
]
